import { FaShippingFast, FaShieldAlt, FaUndo, FaTags } from "react-icons/fa";
import { motion } from "framer-motion";

const features = [
  { icon: <FaShippingFast />, title: "Free Delivery" },
  { icon: <FaShieldAlt />, title: "Secure Payment" },
  { icon: <FaUndo />, title: "Easy Returns" },
  { icon: <FaTags />, title: "Best Prices" },
];

const TrustSection = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 mt-8">

      <div className="flex justify-between items-center flex-wrap gap-6 md:gap-4">

        {features.map((item, i) => (
          <motion.div
            key={i}
            whileHover={{ y: -4, scale: 1.05 }}
            className="flex items-center gap-3 cursor-pointer transition"
          >

            {/* ICON */}
            <div className="
              text-blue-600 
              text-xl sm:text-2xl md:text-3xl
              transition
            ">
              {item.icon}
            </div>

            {/* TEXT */}
            <p className="
              text-sm sm:text-base md:text-lg 
              font-medium text-gray-700
            ">
              {item.title}
            </p>

          </motion.div>
        ))}

      </div>

    </div>
  );
};

export default TrustSection;
